import Icon from '../../../../components/common/Icon/Icon';
import { IconKeys } from '../../../../components/common/Icon/IconKeys';
import S from './AddAudioFileCardStyles';

type Props = {
  onClick: () => void;
  disabled?: boolean;
};

export default function AddAudioFileCard({ onClick, disabled = false }: Props): JSX.Element {
  return (
    <S.Card
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label="Add Audio files. Browse from your computer"
    >
      <S.PlusIcon>
        <Icon iconKey={IconKeys.PLUS} />
      </S.PlusIcon>
      <S.Label>Add Audio files...</S.Label>
      <S.SubLabel>Browse from your computer</S.SubLabel>
    </S.Card>
  );
}
